import { api } from 'controllers/network/apiClient';
import {
  ConfigData,
  ContextResolverDefinitionsResponse,
  ExecuteContextResolverResponse,
  Response,
  ShopperDebugActivePromptsResponse,
  ShopperProductsStatus,
  ShopperProductsStatusResponse,
  ShopperPromptOverrides,
  ShopperPromptOverridesResponse,
  UpdateShopperPromptOverrides,
} from './types';

export async function getShopConfigValues(): Promise<ConfigData> {
  return api.get('/v2/shopper/config');
}

export async function setShopConfigValues(
  data: Partial<ConfigData>,
): Promise<Response> {
  return api.post('/v2/shopper/config', data);
}

export async function turnOffShopperAgent(): Promise<Response> {
  return api.post('/v2/shopper/agent/off');
}

export async function turnOnShopperAgent(): Promise<Response> {
  return api.post('/v2/shopper/agent/on');
}

export async function getShopperDebugActivePrompts(): Promise<ShopperDebugActivePromptsResponse> {
  const response = await api.get<ShopperDebugActivePromptsResponse>(
    '/v2/shopper/debug/active_prompts',
  );

  return response;
}

export async function getShopperProductsStatus(): Promise<ShopperProductsStatus> {
  const response = await api.get<ShopperProductsStatusResponse>(
    '/v2/shopper/products/status',
  );

  return {
    countProductsTotal: response.count_products_total,
    countProductsTruncated: response.count_products_truncated,
    countVariantsTruncated: response.count_variants_truncated,
    isTruncated: response.is_truncated,
    hasFullProductAccess: response.has_full_product_access,
  };
}

export async function getShopPromptOverrides(): Promise<ShopperPromptOverrides | null> {
  const response = await api.get<ShopperPromptOverridesResponse>(
    '/v2/shopper/shop_prompt_overrides',
  );

  return response.data;
}

export async function upsertShopPromptOverrides(
  data: UpdateShopperPromptOverrides,
) {
  return api.post('/v2/shopper/shop_prompt_overrides', data);
}

export async function getContextResolverDefinitions(): Promise<ContextResolverDefinitionsResponse> {
  const response = await api.get<ContextResolverDefinitionsResponse>(
    '/v2/shopper/debug/prompt_context/resolver_definitions',
  );

  return response;
}

export async function postExecuteContextResolver(
  resolverName: string,
  payload: Record<string, unknown>,
): Promise<ExecuteContextResolverResponse> {
  const response = await api.post<ExecuteContextResolverResponse>(
    `/v2/shopper/debug/prompt_context/resolver/${resolverName}`,
    payload,
  );

  return response;
}
